export default function useShareData() {
  const page = usePage()

  const currentUser = computed(() => page.props.currentUser)
  const permissions = computed(() => page.props.permissions)
  const menus = computed(() => page.props.menus)
  const submenus = computed(() => page.props.submenus)
  const operations = computed(() => page.props.operations)

  return {
    currentUser,
    permissions,
    menus,
    submenus,
    operations
  }
}
